import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url:'/attribute/category/list',
    method:'get',
    params:params
  })
}

export function createAttributeCategory(params) {
  return request({
    url:'/attribute/category/create',
    method:'post',
    params: params
  })
}

export function deleteAttributeCategory(id) {
  return request({
    url:'/attribute/category/delete/' + id,
    method:'get'
  })
}

export function updateAttributeCategory(id, params) {
  return request({
    url:'/attribute/category/update/' + id,
    method:'post',
    params: params
  })
}
export function fetchListWithAttr() {
  return request({
    url:'/attribute/category/list/withAttr',
    method:'get'
  })
}
